import React from 'react'
import style from "./style.module.css"
import LogoutImg from "../../../../assets/logout.svg"
import { useDispatch } from 'react-redux'
import { logOutUser } from '../../../../redux/actions/AuthActions'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
const Logout = ({ closePopup }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const logout = () => {
        dispatch(logOutUser())
        toast.success("Logged out successfully!");
        navigate("/login")
        closePopup()
    }
    return (
        <div className={style.mainDiv}>
            <img className={style.logoutImg} src={LogoutImg} alt="..."/>
            <h2>Confirm?</h2>
            <p>Are you sure you have to logout?</p>
            <button onClick={() => logout()} className={style.understoodBtn}>Confirm Logout</button>
            <p style={{marginTop:"1rem", cursor:"pointer", textDecoration:"underline"}} onClick={()=>closePopup()}>Cancel</p>
        </div>
    )

}

export default Logout;
